module.exports = __webpack_public_path__ + "img/icon-success-verified.32c2e4d8.svg";